import React, { memo, ReactNode } from 'react';

import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import useConsumableQuantityEstimationHook from './consumable-quantity-estimation.hook';
import * as styled from './consumable-quantity-estimation.styles';
import themes from './themes';
import DataGrid from '@plasma/ui.display.data-grid';
import Button from '@plasma/ui.general.button';
import { Select } from 'antd';
import EditableTable from '../../components/edit-table';
import Input from '@plasma/ui.input.input'
export interface ConsumableQuantityEstimationProps {

  children?: ReactNode;
  /**
   * Defines custom className
   */
  className?: string;
  /**
   * Defines component's custom style
   */
  style?: React.CSSProperties;
  // add new properties here...
}

type Props = ConsumableQuantityEstimationProps & ThemeOverride;

function ConsumableQuantityEstimation(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const {
    t,
    columnNames,
    displayDataForColumns,
    inputValue,
    setInputValue,
    handleInputChange,
    handleSubmit,
    dataForColumns,
    productType,
    handleProductTypeChange,
    productTypesList,
    productSize,
    handleProductSizeChange,
  } = useConsumableQuantityEstimationHook(props);

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.ConsumableQuantityEstimation
        className={`consumable-quantity-estimation ${className ?? ''}`.trim()}
        style={style}
      >
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Select
            style={{ width: '150px', margin: '5px' }}
            onChange={handleProductTypeChange}
            value={productType}
            placeholder="Product Type"
          >
            {productTypesList?.map(
              (type, index) =>
                productTypesList.indexOf(type) === index && (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ),
            )}
          </Select>
          <Select
            style={{ width: '150px', margin: '5px' }}
            onChange={handleProductSizeChange}
            value={size}
            placeholder="Size"
           // disabled={! (productType?.length)}
          >
           
            {productSize
              ?.filter((value, index, self) => self.indexOf(value) === index)
              .map((size, index) => (
                <option key={index} value={size}>
                  {size}
                </option>
              ))}
          </Select>
          <label
            htmlFor="plannerYear"
            style={{
              border: '1px solid blue',
              paddingRight: '5px',
              marginRight: '10px',
              fontStyle: 'bold',
              color: 'red',
              fontSize: '15px',
            }}
          >
            Enter no. of years:{' '}
          </label>
          <Input
            placeholder={'Enter no of year'}
            value={inputValue}
            onChange={(e) => handleInputChange(e)}
            id="plannerYear"
          />

          <Button title="Submit" type="secondary" onClick={handleSubmit} />
        </div>

        {displayDataForColumns && (
         
          <EditableTable
            tableData={displayDataForColumns}
            tableColumns={columnNames}
            hiddenColumns={[]}
            showActions_ext={false}
            allowSelection={false}
            onlyAddableFields={[]}
            mandatoryFields={[]} handleSave={function (newData: { [key: string]: any; }[] | { [key: string]: any; }, returnType?: string | undefined): void {
              throw new Error('Function not implemented.');
            } } handleSelection={function (selectedRowIndex: number, selectedRowData: { [key: string]: any; }): void {
              throw new Error('Function not implemented.');
            } } saveReturnType={'row'} Table_Header={''} selectInputReturnType={'value'}        />

        )}
        {children}
      </styled.ConsumableQuantityEstimation>
    </ThemeProvider>
  );
}

export default memo(ConsumableQuantityEstimation) as unknown as typeof ConsumableQuantityEstimation;
